import React, { useEffect } from 'react';
import axios from 'axios';
import { StudioPlan } from '../data/utils/plansData';
import { useAtomValue, useSetAtom } from 'jotai';
import { userInfoAtom } from '../data/atoms/utilsAtoms';
import ChargbeeButton from './PlanPage/ChargbeeButton';
import checkApiStatus from './SubscripStatus';
import { Helmet } from 'react-helmet-async';
import api from '../data/api';
import { useVerifySubscription } from '../hook/useVerifySubscription';
import { useNavigate } from 'react-router-dom';

function StudioPlanPage() {
	const userData = useAtomValue(userInfoAtom);
	const setUserData = useSetAtom(userInfoAtom);
	const navigate = useNavigate()
	useEffect(()=> {
		navigate('/plans')
	},[])
	
	useVerifySubscription();

	useEffect(() => {
		const intervalId = setInterval(async () => {
			checkApiStatus(userData.token, setUserData);

			const userId = userData.user?.userId ?? userData?.user?._id;
			if (!userId) {
				return;
			}
			const response = await api.getPersonalInformation(userId);

			setUserData({
				...userData,
				user: {
					...userData.user,
					userType: response?.data?.userType
				}
			});
			localStorage.setItem('userData', JSON.stringify(userData.user));
		}, 3000); // 5000 milliseconds = 5 seconds

		// Cleanup function to clear the interval when the component is unmounted or dependencies change
		return () => clearInterval(intervalId);
	}, [setUserData, userData.user?.toString(), userData.token]);

	axios.defaults.withCredentials = true;

	return (
		<div>
			<Helmet>
				<title>Studio Plans | The Godfrey Method - On Demand</title>
				<meta name="description" content="Studio Plans page of The Godfrey Method - On Demand" />
			</Helmet>
			{/* Mobile  */}

			<div className="row m-0 c-mobile_honm-serch">
				<div className="c-header_search">
					<form action="">
						<input type="text" id="search" placeholder="Search " />
						<button id="search-button" aria-label="search button">
							<span className="c_header-mac">
								<i class="fa-solid fa-microphone"></i>
							</span>
							<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
								<path
									d="M17.8516 17.5L14.2266 13.875M16.1849 9.16667C16.1849 12.8486 13.2001 15.8333 9.51823 15.8333C5.83633 15.8333 2.85156 12.8486 2.85156 9.16667C2.85156 5.48477 5.83633 2.5 9.51823 2.5C13.2001 2.5 16.1849 5.48477 16.1849 9.16667Z"
									stroke="#71717A"
									strokeWidth="1.66667"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</button>
					</form>
				</div>
			</div>
			{/* /////////////////// */}
			<div className="container-c-section">
				{userData.token ? (
					<div className="c-join-section">
						<h1> {userData.token ? `Welcome, ${userData.user.firstname} ${userData.user.lastname}.` : ''}</h1>
					</div>
				) : (
					<div className="c-join-section">
						<h1> Join The Community and Access Exclusive Content</h1>
					</div>
				)}
			</div>
			<div class="c-tab_cata-text c-plane_page-m">
				<h1>STUDIO PLANS</h1>
			</div>
			{/* ///////////////////// */}
			<div className="c-plan_section">
				<div className="c-video_textcol">
					<h3 className="c-plane-mobile_h3">Pick your Studio Plan</h3>
					<h4 className="c-plane-mobile-h4">Pick your Studio Plan</h4>
				</div>

				<div className="c-plan_list">
					{StudioPlan.map((data, index) => (
						<div className="c-plan_new-two" key={index}>
							<div>
								<div className="c_plan_pric-box">
									<h4>{data.name}</h4>
									<h2>
										{data.price}
										<span>/Yearly</span>
									</h2>
									<ul>
										{data.feature.map((feature, index) => (
											<li key={index}>{feature}</li>
										))}
									</ul>

									<ChargbeeButton planType="yearly" newlySignedUp={false} seats={data.seats} isStudio={true} />
								</div>
							</div>
						</div>
					))}
				</div>

				<div className="studio-tagline">
					<span>Looking for an Individual Account?</span> <span className="studio-tag"></span>
					<span className="studio-tag">
						<a href="/Plans">Sign Up</a>
					</span>
				</div>
			</div>
		</div>
	);
}

export default StudioPlanPage;
